export default __webpack_public_path__ + "static/media/up.c09a5b8f.png";